@if (showSkeleton()) {
<div class="chips-container">
  <div class="skeleton-chip"></div>
  <div class="skeleton-chip skeleton-chip--short"></div>
  <div class="skeleton-chip skeleton-chip--medium"></div>
</div>
} @else if (chips().length > 0) {
<!-- Ghost container: off-screen, renders all chips for measurement -->
<div class="ghost-container">
  <div class="chips-container">
    @for (chip of chips(); track trackByChip($index, chip)) {
    <div #ghostChip class="attribute-chip">
      <span class="attribute-chip__text">{{ chip.displayValue }}</span>
      <mat-icon fontIcon="cancel"></mat-icon>
    </div>
    }
  </div>
</div>

<!-- Real container: visible to the user -->
<div class="chips-container">
  @for (chip of visibleChips(); track trackByChip($index, chip)) {
  <div class="attribute-chip" matTooltipClass="custom-tooltip" appCustomTooltip [matTooltip]="chip.tooltip">
    <span class="attribute-chip__text">{{ chip.displayValue }}</span>
    <mat-icon fontIcon="cancel" (click)="onRemove(chip)"></mat-icon>
  </div>
  } @if (overflowCount() > 0) {
  <a class="attribute-chip--overflow" (click)="overflowClicked.emit()" i18n="@@S_ATTRIBUTE_CHIPS_BUTTON_MORE"
    >+{{ overflowCount() }} more</a
  >
  }
</div>
}
